const SETIMG='SETIMG'
const SETNAME='SETNAME'
const SETBASE64='SETBASE64'

// const SHOWRESULT = 'SHOWRESULT'
export default {
  [SETBASE64](state,str){
    state.base64=str;
  },
  [SETIMG](state,str){
    state.imageUrl=str;
  },
  [SETNAME](state,str) {
    state.name = str;
  }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js